import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { useStore } from 'core/store/';
import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { track } from 'core/helpers/analytics';
import useSession from 'core/hooks/use-session';
import Button from 'core/components/button/button';
import OfferCommunityDriveCard from 'common/components/people/community-drive-card/offer-community-drive-card';
import useStyles from './community-drive-discount-modal.styles';

const CommunityDriveDiscountModal = observer(({ onClose }) => {
  const { user } = useSession();
  const classes = useStyles();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const [participationState, setParticipationState] = useState(() => {
    const initialState = {};

    values.drivers.forEach((driver, index) => {
      initialState[index] = !!driver.communityDriveParticipation;
    });
    return initialState;
  });

  const {
    offer: {
      offer: { id: offerId }
    }
  } = useStore();

  const handleDriverChange = (index, isParticipating) => {
    setParticipationState((prev) => ({
      ...prev,
      [index]: isParticipating
    }));
  };

  const handleAddAll = () => {
    const newState = {};
    values.drivers.forEach((_, index) => {
      newState[index] = true;
    });
    setParticipationState(newState);
  };

  const handleRemoveAll = () => {
    const newState = {};
    values.drivers.forEach((_, index) => {
      newState[index] = false;
    });
    setParticipationState(newState);
  };

  const handleConfirm = () => {
    values.drivers.forEach((driver, index) => {
      const currentValue = driver.communityDriveParticipation;
      const newValue = participationState[index];

      if (currentValue !== newValue) {
        setFieldValue(`drivers.${index}.communityDriveParticipation`, newValue);
        setFieldTouched(`drivers.${index}.communityDriveParticipation`, true);
      }
    });

    track('Community Drive participation modified', {
      user: user.username,
      offerId
    });

    onClose();
  };

  useEffect(() => {
    const updatedState = {};

    values.drivers.forEach((driver, index) => {
      updatedState[index] = driver.communityDriveParticipation;
    });

    setParticipationState(updatedState);
  }, [values.drivers]);

  return (
    <BaseDialog onClose={onClose} open>
      <Label marginBottom={5} type="subtitle">
        Community Drive Discount
      </Label>
      <Label type="modalBody" className={classes.description}>
        Participating drivers in our Community Drive telematics program:
      </Label>
      {values.drivers.map((driver, i) => (
        <Grid item key={driver.id} className={classes.driverCardContainer}>
          <OfferCommunityDriveCard
            fieldName={`drivers.${i}`}
            driver={driver}
            isParticipating={participationState[i]}
            onChange={(isParticipating) => handleDriverChange(i, isParticipating)}
          />
        </Grid>
      ))}
      <Grid container direction="row" justifyContent="flex-end">
        <Grid item className={classes.actionBtnContainer}>
          <Button className={classes.actionBtn} color="secondary" onClick={handleAddAll}>
            Add all
          </Button>
          <Button className={classes.actionBtn} color="secondary" onClick={handleRemoveAll}>
            Remove all
          </Button>
        </Grid>
        <Grid item>
          <Button className={classes.confirmBtn} mode="big" variant="contained" color="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </Grid>
      </Grid>
    </BaseDialog>
  );
});

export default CommunityDriveDiscountModal;
